import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import { PricingByCard } from "../../pricing/components/pricing-by-card";
import { PricingCard } from "../../pricing/components/pricing-card";
import { PricingByPatch, PricingPatch } from "../../pricing/types/pricing";
import {
  updateOmniContractCache,
  useOmniContractPatchMutation,
} from "../api/contract-api";
import { Contract, patchContract } from "../types/contract";
import { omniPricingByCardConfig } from "../../servicekindrules/omni-pricing-by-card-config";
import { omniPricingCardConfig } from "../../servicekindrules/omni-pricing-card-config";

export function ContractPricingPage({ contract }: { contract: Contract }) {
  const [patch] = useOptimisticDebouncedMutation(
    { id: contract.id },
    updateOmniContractCache,
    useOmniContractPatchMutation(),
  );

  const patchPricing = (pricing: PricingPatch) =>
    patch({ id: contract.id, pricing }, patchContract(contract, { pricing }));
  const patchPricingBy = (pricingBy: PricingByPatch) =>
    patch(
      { id: contract.id, pricingBy },
      patchContract(contract, { pricingBy }),
    );

  return (
    <div className="grid gap-2">
      <PricingCard
        pricing={contract.pricing}
        onPatch={patchPricing}
        disabled={isImmutable(contract)}
        {...omniPricingCardConfig}
      />
      <PricingByCard
        document={contract}
        pricingBy={contract.pricingBy}
        onPatch={patchPricingBy}
        disabled={isImmutable(contract)}
        {...omniPricingByCardConfig}
      />
    </div>
  );
}
